import React, { ChangeEvent } from 'react'
import ModalArchivedScheduleNotification from '../../../ScheduleNotification/EditScheduleNotificationView/ConModalArchivedScheduleNotification/ModalArchivedScheduleNotification/ModalArchivedScheduleNotification'

type ConModalArchivedScheduleEmailProps = {
    onSubmit: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void
    onCloseModal: () => void
}

const ConModalArchivedScheduleEmail = ({
    onSubmit,
    onCloseModal,
}: ConModalArchivedScheduleEmailProps) => {

    const handleClickOutsideModal = (e: any) => {
        const clickOutsideModal = document.getElementById("background-aux-modal")?.contains(e.target);
        if(!clickOutsideModal && e.target.id === "darkened-background-modal"){
            //dispatch( setShowJobModalRequestReducer(false) )
            onCloseModal()
        }
            
    }
  
    return (
        <>
            {
                <div onClick={(e) => { handleClickOutsideModal(e) }} id={"darkened-background-modal"} className="background-gray center">
                    <div id={"background-aux-modal"}>
                          <ModalArchivedScheduleNotification
                                onCloseModal={onCloseModal}
                                onSubmit={onSubmit}
                          />
                    </div>
                </div>
            }
        </>
    )
}

export default React.memo( ConModalArchivedScheduleEmail )